import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Spacing } from "@snapchat/snap-design-system";

export const FilterRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    margin: ${Spacing.LG}px 0 0;
`;

export const filter = css`
    margin-right: ${Spacing.LG}px;
`;
